import React from 'react';
import { Hidden } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useCompensationSetting } from '../../../components/use-compensation-setting';
import { OneTimePayment } from './compensation-history-model';
import { OneTimePaymentView } from './one-time-payment-view';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { compHistoryTableStyles } from '../../../../../global/constants/theme/styles/tables/comp-history-tables';
import { TcsmStates } from '../../../../../root/tcsm-model';



export function OneTimePayments() {
    const tableClasses = compHistoryTableStyles();
    const settings = useCompensationSetting();
    const oneTimePayments = useSelector<TcsmStates, OneTimePayment[]>(state => state.compensationHistoryState?.oneTimePayments);

    if (!oneTimePayments || oneTimePayments.length === 0) {
        return <p>{settings.emptyOneTimePaymentMessage}</p>;

    }

    return (
        <DividerSection removeDivider sectionText={settings?.oneTimePaymentTitle}>
            <div className={tableClasses.paymentTable}>
                <Hidden smDown>
                    <div className='payment-table-row'>
                        <div className='payment-table-cell'>
                            <p className='input-label'>{settings?.effectiveDateOneTimeLabel}</p>
                        </div>
                        <div className='payment-table-cell'>
                            <p className='input-label'>{settings?.amountLabel}</p>
                        </div>
                        <div className='payment-table-cell'>
                            <p className='input-label'>{settings?.assessableLabel}</p>
                        </div>

                    </div>
                </Hidden>
                <div className='payment-table-content'>
                    {
                        oneTimePayments?.map((a, idx) =>
                            <OneTimePaymentView
                                key={`opt-${idx}`}
                                payment={a}
                                effectiveDateOneTimeLabel={settings?.effectiveDateOneTimeLabel}
                                amountLabel={settings?.amountLabel}
                                assessableLabel={settings?.assessableLabel}
                            />)
                    }
                </div>
            </div>
        </DividerSection>
    );
}